import { Outlet } from 'react-router-dom'
import { ServiceProvider, useService } from '../contexts/ServiceContext'
import LoadingState from '../shared/components/LoadingState'
import ErrorState from '../shared/components/ErrorState'

function ServiceContent() {
  const { loading, error } = useService()

  if (loading) return <LoadingState />
  if (error) return <ErrorState messageId="dockerServices.error" />

  return <Outlet />
}

function ServiceLayout() {
  return (
    <ServiceProvider>
      <ServiceContent />
    </ServiceProvider>
  )
}

export default ServiceLayout
